import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { DEFAULT_LABEL_COLOR } from "../../../constants/pickerColors";
import LabelsDialog from "../../labels/LabelsDialog";

/**
 * Displays task labels as:
 * - A single pill if only one label
 * - Colored dots if multiple labels
 *
 * Clicking on either opens the labels dialog
 */
const LabelDisplay = ({ labels, taskId, onLabelsChange, onLabelRemoved }) => {
  const { labels: userLabels } = useSelector((state) => state.user);
  const [showLabelsDialog, setShowLabelsDialog] = useState(false);

  if (!labels || labels.length === 0) {
    return null;
  }

  // Filter out invalid labels
  const validLabels = labels
    .map((labelId) => userLabels?.[labelId])
    .filter((label) => label != null);

  if (validLabels.length === 0) {
    return null;
  }

  const isSingleLabel = validLabels.length === 1;
  const isEditable = onLabelsChange && onLabelRemoved;

  const handleLabelClick = (e) => {
    if (!isEditable) return;
    e.stopPropagation(); // Prevent event bubbling to parent elements
    setShowLabelsDialog(true);
  };

  return (
    <>
      <div
        className={`task__label-container ${isSingleLabel ? "task__label-container--single" : "task__label-container--multiple"} ${isEditable ? "task__label-container--editable" : ""}`}
        onClick={handleLabelClick}
      >
        {isSingleLabel ? (
          // Single label - show as pill
          <div
            className="label-pill"
            style={{
              "--label-color": validLabels[0].color || DEFAULT_LABEL_COLOR,
            }}
            data-label-color={validLabels[0].color || DEFAULT_LABEL_COLOR}
          >
            <Typography
              variant="labelWhiteNoMargin"
              className="label-pill__text"
            >
              {validLabels[0].name}
            </Typography>
          </div>
        ) : (
          // Multiple labels - show as colored dots
          <div className="task__label-dots">
            {validLabels.map((label) => (
              <div
                key={`task-label-dot__${label.labelId}`}
                className="task__label-dot"
                style={{
                  "--label-color": label.color || DEFAULT_LABEL_COLOR,
                }}
                title={label.name}
              />
            ))}
          </div>
        )}
      </div>

      {/* Labels Dialog Modal - Only show if editable */}
      {isEditable && showLabelsDialog && (
        <LabelsDialog
          open={showLabelsDialog}
          onClose={() => setShowLabelsDialog(false)}
          selectedLabels={labels}
          onSelectedLabelsChange={onLabelsChange}
          onLabelRemoved={onLabelRemoved}
        />
      )}
    </>
  );
};

export default LabelDisplay;
